import gql from 'graphql-tag'

export const inviteToPlatformMutation = gql`
  mutation SendConnectionInvitation($studentIds: [ID!]!) {
    SendConnectionInvitation(studentIds: $studentIds) {
      message
      success
    }
  }
`

export const coachingLeadViewedMutation = gql`
  mutation CoachingLeadViewed($id: ID!) {
    CoachingLeadViewed(inquiryId: $id) {
      message
      success
      leadId
    }
  }
`
